import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "sub-header h-300px d-flex justify-content-center shadow",
  style: {"background-image":"url('https://www.perufedup.com/wp-content/uploads/2019/03/46514394_2491693697512127_3214782836372406272_o.jpg')"}
}
const _hoisted_2 = { class: "content z-index-1 text-center text-white mx-10" }
const _hoisted_3 = { class: "fs-2x mb-8" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", {
        class: "fs-5 fw-light",
        innerHTML: _ctx.subTitle
      }, null, 8, _hoisted_4)
    ])
  ]))
}